<template>
<v-container fluid pa-0 ma-0 >
<v-layout  >
  <v-flex xs5 sm5>
    <v-btn @click.stop="printDialog()"  color="primary" dark><v-icon class="mr-2">payment</v-icon>Checkout</v-btn>
  </v-flex><v-spacer/>
    <v-flex xs4 sm5 >
    <v-chip color="primary accent-3" text-color="white" v-if="itemCount >0">
      <v-avatar class="primary darken-2" right>{{ itemCount }}</v-avatar>
      <div>{{ totalCT }}</div></v-chip>
    </v-flex><v-spacer/>
  <v-flex xs2 >
    <v-btn @click.stop="closeSaleForm(true)" fab right color="primary" dark><v-icon>add</v-icon></v-btn>
  </v-flex><v-spacer/>
</v-layout>

<v-layout>
<v-dialog persistent v-model="dialog" max-width="500px">  
  <v-card >
  <v-card-title class="headline justify-center">{{ formTitle }}</v-card-title>
    <v-container fluid>
    <v-layout>
    <v-flex xs12>
      <v-autocomplete
        v-model="productname"
        :items="items"
        item-text="name"
        label="Select a Product"
        return-object
        @click:append=true
        ref="pname"
        >
        <template slot="no-data">
          <v-btn color=success>add new Product</v-btn>
        </template>
      </v-autocomplete>
  </v-flex>
  </v-layout>

  <v-layout >
    <v-flex xs12>
      <v-text-field
      type="tel"
      label="Quantity"
      v-model="qty"
      ref="1"
      id="qty"
      :suffix=unit
      v-on:keyup.enter="gonext('2')"
      ></v-text-field>
    </v-flex>
  </v-layout>

  <v-layout>
    <v-flex>
      <v-text-field
      label="Rate"
      v-model="rate"
      type="tel"
      ref="2"
      v-on:keyup.enter="gonext('3')"
      ></v-text-field>
      <h4>total = Rs. {{ total_cal }} </h4>
    </v-flex>
  </v-layout>

  <v-layout>
    <v-flex  >
      <v-text-field
      label="Discount"
      type="tel"
      v-model="discount"
      ref="3"
      v-on:keyup.enter="add('add')"
      ></v-text-field>
      <h4>total After Discount = Rs. {{ totalwd }} </h4>
    </v-flex>
  </v-layout>

  <v-layout>

    <v-flex xs3>
      <v-btn
      color="success"
      @click.stop="invlist"
      ref="add"
      id="add"
      >{{btnTitle}}</v-btn></v-flex>
      <v-flex>
      <v-btn color="success" @click.native="closeSaleForm(false)">close</v-btn>
    </v-flex>
  </v-layout>

  </v-container>
  </v-card>
</v-dialog>
</v-layout>
</v-container>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  computed: {
  
  total_cal() {
    return this.$store.getters['invoice/total']
  },
  totalwd(){
    return this.$store.getters['invoice/totalwd']
  },
  formTitle () {
    return this.$store.state.invoice.editedIndex === -1 ? 'Add New Item' : 'Edit An Item'
    },
  btnTitle() {
    return this.$store.state.invoice.editedIndex === -1 ? 'Add New' : 'Modify'
  },
  items () {
    return this.$store.state.invoice.items //getters['invoice/getItems']
  },
  productname: {
    get(){
      return this.$store.state.invoice.editlist.select
    },
    set (value){
      this.$store.dispatch('invoice/productname', value)
    }
  },
  qty: {
    get() {
    },
    set (qty) {
      this.$store.dispatch('invoice/qty', qty)
    }
  },
  unit() {
    return this.$store.state.invoice.editlist.select.unit
  },
  discount: {
    get () {
      return this.$store.state.invoice.editlist.discount
    },
    set ( discount) {
      this.$store.dispatch('invoice/discount', discount)
    }
  },
  rate: {
    get () {
      return this.$store.state.invoice.editlist.select.rate
    },
    set ( rate) {
      this.$store.dispatch('invoice/rate', rate)
    }
  },

  dialog() {
    if (this.$store.state.invoice.dialog ==true) {
      }
    return this.$store.state.invoice.dialog
    },
  totalCT() {
    return this.$store.state.invoice.totalCT
  },
  itemCount() {
    if (this.$store.state.invoice.list.length > 0 )
    {
      return this.$store.state.invoice.list[this.$store.state.invoice.list.length -1].sl
    }
    else {
      return 0
    }
  },
  },
  methods: {
    add(ref) {
      this.$nextTick( () => {
        this.$refs[ref].$el.focus()
      })
    },
    invlist(value) {  
      this.$store.dispatch('invoice/listItem')
      //this.closeSaleForm(value)
      this.$nextTick(()=>{
        this.$refs.pname.focus()
  })
    },
    gonext(ref){
      this.$nextTick(() => {
        this.$refs.pname.isActive =false
        this.$refs[ref].focus()
      })
    },

    closeSaleForm(value) {
      this.$store.dispatch('invoice/closeSaleForm',value)
      this.gonext("pname")
    },
    printDialog () {
      this.$store.dispatch('printDialog')
  }
  },
  async mounted() {
    this.$store.dispatch('invoice/fetchitem')
    this.$store.dispatch('invoice/stcode')
  }
}
</script>
I